module.exports = __webpack_public_path__ + "images/friendly_alexia-176612f308a22fafc5a922269522bf21.png";